import {
  IElementCategory,
  ElementCategoryID,
} from '../../../models/element-categories.model';
import {
  InsulationMaterial,
  InsulationPropertyName,
  WoodFibre,
  CelluloseFibre,
} from './insulation.model';
import {
  DEFAULT_AREAL_DENSITY_PROPERTIES,
  DEFAULT_QUANTITY_EXPRESSIONS,
  DEFAULT_QUANTITY_PROPERTIES,
} from '../../../models/element-quantities.model';
import {
  getElementPropertySelectionByValue,
  getValueFromConditionalNodes,
} from '../../../helpers/conditional-nodes.helpers';
import { insulationProperties } from './insulation-properties';
import { ProductID } from '../../../models/product.model';
import { insulationProductIds } from './insulation-product-ids';

// TODO Fix these formulas to use conductivity to calculate density
// const termalDensityEPS = `firstNonZero((0.0075 * (${InsulationPropertyName.ThermalConductivity} ^ 2)) + (0.47 * ${InsulationPropertyName.ThermalConductivity}) + 5.67)`;
// const termalDensityXPS = `firstNonZero((0.0005 * (${InsulationPropertyName.ThermalConductivity} ^ 3)) + (0.0068 * ${InsulationPropertyName.ThermalConductivity}) + (0.1243 * ${InsulationPropertyName.ThermalConductivity}) + 1)`;
const termalDensityEPS = '25';
const termalDensityXPS = '35';
const densityBlowingWhool = `50`;

const epdDensity = 'densityArray[1]';

const isEPS = `${InsulationPropertyName.material} == "${InsulationMaterial.EPS}"`;
const isXPS = `${InsulationPropertyName.material} == "${InsulationMaterial.XPS}"`;
const isWoodFibreBlowingWhool = `(${InsulationPropertyName.material} == "${InsulationMaterial.WoodFibre}" and ${InsulationPropertyName.form} == "${WoodFibre.BlowingWool}")`;
const isCelluloseFibreBlowingWhool = `(${InsulationPropertyName.material} == "${InsulationMaterial.CelluloseFibre}" and (${InsulationPropertyName.form} == "${CelluloseFibre.BlowingWoolPostConsumerPaper}" or ${InsulationPropertyName.form} == "${CelluloseFibre.BlowingWoolPrimaryRawMaterial}" or ${InsulationPropertyName.form} == "${CelluloseFibre.BlowingWoolRecycledPrimaryPaper}"))`;

const epsExpression = `${isEPS} ? ${termalDensityEPS} : 0`;
const xpsExpression = `${isXPS} ? ${termalDensityXPS} : 0`;
const blowingWhoolExpression = `${isWoodFibreBlowingWhool} or ${isCelluloseFibreBlowingWhool} ? ${densityBlowingWhool} : 0`;

const insulationDensityCount = `firstNonZero(${epdDensity}, ${epsExpression}, ${xpsExpression}, ${blowingWhoolExpression}, ${DEFAULT_QUANTITY_EXPRESSIONS.density})`;

export const insulation: IElementCategory = {
  id: ElementCategoryID.Insulation,
  defaultSelectedQuantity: 'mass',
  name: 'Insulation',
  color: '#C4C758',
  properties: insulationProperties,
  getQuantityProperties: () => ({
    ...DEFAULT_QUANTITY_PROPERTIES,
    ...DEFAULT_AREAL_DENSITY_PROPERTIES,
    density: {
      fallbackCount: insulationDensityCount,
    },
  }),
  // `throwIfNotFound: false` + `undefined` passthrough: insulation has
  // material→form conditionals (forms differ per material) so a proposal can
  // transiently pair an invalid material+form before downstream auto-reset.
  // `undefined` skips enrichment and preserves existing children rather than
  // stripping them.
  getChildElements: (element) =>
    getValueFromConditionalNodes(element, [insulationProductIds], false),
  getElementPropertySelectionByProductId: (productId: ProductID) =>
    getElementPropertySelectionByValue(productId, insulationProductIds),
};
